import { memo } from 'react';
import { ListItem, ListItemIcon, ListItemText, Avatar, Typography } from '@mui/material';
import { LocalShipping, CheckCircle, Block, Payment } from '@mui/icons-material';
import { useTranslation } from '@/kit/useTranslation';

const TransactionItem = memo(({ transaction }) => {
  const { t } = useTranslation();
  const isCredit = transaction.type === 'credit';

  // Determine icon based on category
  let IconComponent = Payment;
  if (transaction.category === 'booking') IconComponent = LocalShipping;
  else if (transaction.category === 'refund') IconComponent = CheckCircle;
  else if (transaction.category === 'blocked') IconComponent = Block;

  // Generate appropriate title
  let title = transaction.description;
  if (isCredit) {
    title = t('payment.transactions.walletTopUp');
  } else if (transaction.category === 'booking' && transaction.parcelId) {
    title = t('payment.transactions.bookingWithId', { id: transaction.parcelId });
  }

  return (
    <ListItem
      sx={{
        borderRadius: 2,
        mb: 1,
        bgcolor: '#fafafa',
        borderBottom: '1px solid #e0e0e0',
        pb: 1.5,
        '&:hover': {
          bgcolor: '#f5f5f5',
        },
        '&:last-child': {
          borderBottom: 'none',
        },
      }}
    >
      <ListItemIcon>
        <Avatar
          sx={{
            bgcolor: isCredit ? '#4caf5015' : '#f4433615',
            color: isCredit ? '#4caf50' : '#f44336',
            width: 40,
            height: 40,
          }}
        >
          <IconComponent sx={{ fontSize: 20 }} />
        </Avatar>
      </ListItemIcon>
      <ListItemText
        primary={
          <Typography variant="body2" fontWeight={600}>
            {title}
          </Typography>
        }
        secondary={
          <Typography variant="caption" color="text.secondary">
            {transaction.date} • {transaction.transactionId || transaction.id}
          </Typography>
        }
      />
      <Typography variant="body1" fontWeight={700} color={isCredit ? '#4caf50' : '#f44336'}>
        {isCredit ? '+' : '-'}₹{transaction.amount}
      </Typography>
    </ListItem>
  );
});

TransactionItem.displayName = 'TransactionItem';

export default TransactionItem;
